export default "__VITE_ASSET__707fdc5c__"